// extracted by mini-css-extract-plugin
export default {"label":"MessagingHorizontalMenuLabel_label__rfjlP","indicator":"MessagingHorizontalMenuLabel_indicator__xaS8N"};